import apiHelper from '../utils/apiHelper';

export const talentsService = {
    getAllTalents: async () => {
        try {
            const response = await apiHelper.get('/api/graph/talents?includeAll=true');
            return response.data || [];
        } catch (error) {
            console.error('Error fetching talents:', error);
            throw error;
        }
    },

    createTalent: async (talentData) => {
        try {
            const fields = {
                Title: talentData.Title || null,
                Text: talentData.Text || null,
                Image: talentData.Image || null,
                Link: talentData.Link || null,
                Published: talentData.Published !== false,
            };

            const response = await apiHelper.post('/api/graph/addTalent', fields);
            return response;
        } catch (error) {
            console.error('Error creating talent:', error);
            throw error;
        }
    },

    updateTalent: async (talentId, talentData) => {
        try {
            const fields = {
                Title: talentData.Title || null,
                Text: talentData.Text || null,
                Image: talentData.Image || null,
                Link: talentData.Link || null,
                Published: talentData.Published !== false,
            };

            const response = await apiHelper.put(`/api/graph/updateTalent/${talentId}`, { fields });
            return response.data;
        } catch (error) {
            console.error('Error updating talent:', error);
            throw error;
        }
    },

    deleteTalent: async (talentId) => {
        try {
            const response = await apiHelper.delete(`/api/graph/deleteTalent/${talentId}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting talent:', error);
            throw new Error(error.response?.data?.message || 'Failed to delete talent');
        }
    },
};
